import { Directive, Injectable, Input } from '@angular/core';
import { AbstractControl, AsyncValidator, NG_ASYNC_VALIDATORS, ValidationErrors } from '@angular/forms';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { User } from '../app/models/User';
import { UserService } from '../services/user.service';

@Directive({
  selector: '[payUniqueUsername][formControlName],[payUniqueUsername][formControl],[payUniqueUsername][ngModel]',
  providers: [{ provide: NG_ASYNC_VALIDATORS, useExisting: UniqueUsernameDirective, multi: true }],
})
@Injectable()
export class UniqueUsernameDirective implements AsyncValidator {
  @Input()
  payInitialValue: string;

  constructor(private userService: UserService) {}

  validate(ctrl: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
    let username = ctrl.value;
    if (username == this.payInitialValue) {
      return new Observable<{}>();
    } else {
      return this.userService.getUserByUsername(username).pipe(
        map((user: User) => {
          return user ? { payUniqueUsername: true } : null;
        }),
        catchError((err) => {
          return new Observable<{}>();
        })
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/directives/unique-username-validator.directive.ts